import { useState } from "react";
import { Button, Table, Form } from "react-bootstrap";
import currency from "currency.js";
import CloseIcon from "mdi-react/CloseIcon";
import PlusIcon from "mdi-react/PlusIcon";
import { toast } from "react-toastify";
import { formatDate, formatForQty } from "../../../utils/helpers";
import DamageBatchPicker from "./DamageBatchPicker";

export default function DamageRequestPreviewItemsTable({
  tableData = [],
  setTableData,
  editable = false,
}) {
  const [showBatchPicker, setShowBatchPicker] = useState(false);

  const handleQuantityChange = (index, value) => {
    const qty = Number(value);
    const row = tableData[index];

    if (value !== "" && qty > Number(row.availableQuantity)) {
      toast.error(`Qty cannot exceed available quantity (${row.availableQuantity})`);
      return;
    }

    const updated = [...tableData];
    updated[index] = { ...row, quantity: value };
    setTableData(updated);
  };

  const handleSalvageCostChange = (index, value) => {
    const updated = [...tableData];
    updated[index] = { ...updated[index], salvageCost: value };
    setTableData(updated);
  };

  const handleRemove = index => {
    setTableData(tableData.filter((_, i) => i !== index));
  };

  const handleAdd = rows => {
    setTableData([...tableData, ...rows]);
    setShowBatchPicker(false);
  };

  return (
    <div className="mb-4">
      <Table borderless striped className="product-table">
        <thead>
          <tr>
            {editable && <th />}
            <th>S/N</th>
            <th>Item Name</th>
            <th>Batch</th>
            <th>ATC Code</th>
            <th>Unit Cost</th>
            <th>Available Qty</th>
            <th>Expiry Date</th>
            <th>Qty to Damage</th>
            <th>Salvage Cost</th>
          </tr>
        </thead>
        <tbody>
          {tableData.length === 0 ? (
            <tr>
              <td colSpan={editable ? 10 : 9} className="text-center py-3">
                No items added yet
              </td>
            </tr>
          ) : (
            tableData.map((el, index) => (
              <tr key={`${el.batchBarCode}-${index}`}>
                {editable && (
                  <td>
                    <Button
                      variant=""
                      size="sm"
                      className="text-danger"
                      onClick={() => handleRemove(index)}
                    >
                      <CloseIcon size={16} />
                    </Button>
                  </td>
                )}
                <td>{index + 1}</td>
                <td>{el.itemName}</td>
                <td>
                  {el.batchBarCode ? el.batchBarCode.split("-").pop() : "..."}{" "}
                  {el.batchName ? <i>({el.batchName})</i> : null}
                </td>
                <td>{el.atcCode || "..."}</td>
                <td>
                  {currency(el.unitCost, {
                    precision: 2,
                    symbol: "",
                  }).format()}
                </td>
                <td>
                  {currency(el.availableQuantity, {
                    precision: 2,
                    format: formatForQty,
                    symbol: "",
                  }).format()}
                </td>
                <td className="text-nowrap">
                  {el.expireDate ? formatDate(el.expireDate, "dd MMM, yyyy") : "..."}
                </td>
                <td>
                  {editable ? (
                    <Form.Control
                      type="number"
                      min={0}
                      max={el.availableQuantity}
                      style={{ width: "100px" }}
                      value={el.quantity}
                      onChange={e => handleQuantityChange(index, e.target.value)}
                    />
                  ) : (
                    currency(el.quantity, {
                      precision: 2,
                      format: formatForQty,
                      symbol: "",
                    }).format()
                  )}
                </td>
                <td>
                  {editable ? (
                    <Form.Control
                      type="number"
                      min={0}
                      style={{ width: "100px" }}
                      value={
                        el.salvageCost === undefined || el.salvageCost === null
                          ? el.unitCost
                          : el.salvageCost
                      }
                      onChange={e =>
                        handleSalvageCostChange(index, e.target.value)
                      }
                    />
                  ) : (
                    currency(
                      el.salvageCost === undefined || el.salvageCost === null
                        ? el.unitCost
                        : el.salvageCost,
                      { precision: 2, symbol: "" }
                    ).format()
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {editable && (
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => setShowBatchPicker(true)}
        >
          <PlusIcon size={16} /> Add Item
        </Button>
      )}

      {showBatchPicker && (
        <DamageBatchPicker
          show={showBatchPicker}
          onHide={() => setShowBatchPicker(false)}
          onAdd={handleAdd}
          existingBarcodes={tableData.map(el => el.batchBarCode)}
        />
      )}
    </div>
  );
}
